// Admin Dashboard
const AdminDashboardMenu = [
  {
    title: 'Dashboard',
    href: '/hrd12/hrd12/dashboard',
    icon: 'mdi-view-dashboard'
  },
  {
    title: 'Transaction Calculator',
    href: '/hrd12/hrd12/transaction-calculator',
    icon: 'mdi-calculator-variant-outline'
  },
  {
    title: 'Giftcards',
    href: '/hrd12/hrd12/giftcard',
    icon: 'mdi-wallet-giftcard',
    children: [
      {
        title: 'Processed Giftcards',
        href: '/hrd12/hrd12/giftcard/processed'
      },
      { title: 'Pending Giftcards', href: '/hrd12/hrd12/giftcard/pending' },
      { title: 'Declined Giftcards', href: '/hrd12/hrd12/giftcard/declined' }
    ]
  },
  {
    title: 'Purchase',
    href: '/hrd12/hrd12/purchase',
    icon: 'mdi-cart-arrow-up',
    children: [
      {
        title: 'Processed Purchase',
        href: '/hrd12/hrd12/purchase/processed'
      },
      { title: 'Pending Purchase', href: '/hrd12/hrd12/purchase/pending' },
      { title: 'Declined Purchase', href: '/hrd12/hrd12/purchase/declined' }
    ]
  },
  {
    title: 'Sales',
    href: '/hrd12/hrd12/sales',
    icon: 'mdi-cart-arrow-down',
    children: [
      {
        title: 'Processed Sales',
        href: '/hrd12/hrd12/sales/processed'
      },
      { title: 'Pending Sales', href: '/hrd12/hrd12/sales/pending' },
      { title: 'Declined Sales', href: '/hrd12/hrd12/sales/declined' }
    ]
  },
  // {
  //   title: 'Airtime',
  //   href: '/hrd12/hrd12/airtime',
  //   icon: 'mdi-cards'
  // },
  {
    title: 'Users Management',
    href: '/hrd12/hrd12/users-management',
    icon: 'mdi-account-cog',
    children: [
      {
        title: 'Users',
        href: '/hrd12/hrd12/users-management/users'
      },
      {
        title: 'User Stats',
        href: '/hrd12/hrd12/users-management/user-stats-filter'
      },
      {
        title: 'Feedbacks',
        href: '/hrd12/hrd12/users-management/feedbacks'
      },
      {
        title: 'Staffs',
        href: '/hrd12/hrd12/users-management/staffs'
      },
      {
        title: 'Ambassador',
        href: '/hrd12/hrd12/users-management/ambassador'
      },
      {
        title: 'SnappyGift',
        href: '/hrd12/hrd12/users-management/funds-transfer'
      },
      // {
      //   title: 'Admin Funds Transfer',
      //   href: '/hrd12/hrd12/users-management/hrd12-funds-transfer'
      // },
      {
        title: 'User Referrals',
        href: '/hrd12/hrd12/users-management/referrals'
      },
      {
        title: 'Bonus Conversion',
        href: '/hrd12/hrd12/users-management/bonus-conversion'
      },
      {
        title: 'Token Conversion',
        href: '/hrd12/hrd12/users-management/token-conversion'
      },
      {
        title: 'Wallet',
        href: '/hrd12/hrd12/users-management/user-wallet'
      },
      {
        title: 'Cashback',
        href: '/hrd12/hrd12/users-management/user-cashback'
      },
      // {
      //   title: 'Crypto Wallets',
      //   href: '/hrd12/hrd12/users-management/crypto-wallets'
      // },
      {
        title: 'Wallet History',
        href: '/hrd12/hrd12/users-management/user-wallet-history'
      },
      {
        title: 'Crypto Wallet History',
        href: '/hrd12/hrd12/users-management/crypto-wallet-history'
      },
      {
        title: 'Cashback History',
        href: '/hrd12/hrd12/users-management/cashback-wallet-history'
      },
      {
        title: 'Bill History',
        href: '/hrd12/hrd12/users-management/user-bill-history'
      }
    ]
  },
  {
    title: 'Wallet Funding Requests',
    href: '/hrd12/hrd12/wallet-funding',
    icon: 'mdi-wallet-plus'
  },
  {
    title: 'Flagged Deposits',
    href: '/hrd12/hrd12/flagged-deposits',
    icon: 'mdi-flag-outline'
  },
  {
    title: 'Withdrawals',
    href: '/hrd12/hrd12/withdrawals',
    icon: 'mdi-bank-transfer',
    children: [
      {
        title: 'Processed',
        href: '/hrd12/hrd12/withdrawals/processed'
      },
      {
        title: 'Pending',
        href: '/hrd12/hrd12/withdrawals/pending'
      },
      {
        title: 'Declined',
        href: '/hrd12/hrd12/withdrawals/declined'
      }
    ]
  },
  // {
  //   title: 'Message Center',
  //   href: '/hrd12/hrd12/messages',
  //   icon: 'mdi-message',
  //   children: [
  //     {
  //       title: "Customers' Request",
  //       href: '/hrd12/hrd12/messages/customers-request'
  //     },
  //     {
  //       title: "Customers' Testimonials",
  //       href: '/hrd12/hrd12/messages/customers-testimonials'
  //     },
  //     {
  //       title: 'Broadcast',
  //       href: '/hrd12/hrd12/messages/broadcast-message'
  //     },
  //     {
  //       title: 'All Subscribers',
  //       href: '/hrd12/hrd12/messages/all-subscribers'
  //     }
  //   ]
  // },
  {
    title: 'Settings',
    href: '/hrd12/hrd12/settings',
    icon: 'mdi-cogs',
    children: [
      {
        title: 'Giftcards',
        href: '/hrd12/hrd12/settings/giftcard'
      },
      {
        title: 'Airtime',
        href: '/hrd12/hrd12/settings/airtime'
      },
      {
        title: 'System Setttings',
        href: '/hrd12/hrd12/settings/system-settings'
      },
      {
        title: 'System Currencies',
        href: '/hrd12/hrd12/settings/system-currencies'
      },
      {
        title: 'Currencies Rate',
        href: '/hrd12/hrd12/settings/system-currencies-rate'
      },
      {
        title: 'Payment Gateways',
        href: '/hrd12/hrd12/settings/payment-gateway'
      },
      {
        title: 'Bank Account Settings',
        href: '/hrd12/hrd12/settings/bank-account'
      },
      {
        title: 'Withdrawal Methods',
        href: '/hrd12/hrd12/settings/withdrawal-methods'
      },
      {
        title: 'Trustee',
        href: '/hrd12/hrd12/settings/trustees'
      },
      {
        title: 'Rank & Rewards',
        href: '/hrd12/hrd12/settings/rank-rewards'
      }
    ]
  },
  {
    title: 'Promo Codes',
    href: '/hrd12/hrd12/promo-codes/promo-codes',
    icon: 'mdi-percent-outline',
    children: [
      {
        title: 'Promo Codes',
        href: '/hrd12/hrd12/promo-codes/promo-codes'
      },
      {
        title: 'Promo Code History',
        href: '/hrd12/hrd12/promo-codes/promo-code-history'
      }
    ]
  },
  {
    title: "Trader's Post",
    href: '/hrd12/hrd12/traders-post',
    icon: 'mdi-message-text-outline'
  },
  {
    title: 'Announcement',
    href: '/hrd12/hrd12/announcement',
    icon: 'mdi-message-text-outline'
  },
  {
    title: 'Leaderboard',
    href: '/hrd12/hrd12/leaderboard',
    icon: 'mdi-view-dashboard'
  }
]

export { AdminDashboardMenu }
